// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LogOut: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11">
            <path
                fill="currentColor"
                d="M3.75,9 L2.25,9 C1.83585942,9 1.5,8.66414094 1.5,8.25 L1.5,2.25 C1.5,1.83585978 1.83585942,1.5 2.25,1.5 L3.75,1.5 C4.16414058,1.5 4.5,1.16414022 4.5,0.75 C4.5,0.335859776 4.16484368,0 3.75,0 L2.25,0 C1.00734365,0 0,1.00734401 0,2.25 L0,8.25 C0,9.49265599 1.00734365,10.5 2.25,10.5 L3.75,10.5 C4.16414058,10.5 4.5,10.1641409 4.5,9.75 C4.5,9.33585906 4.16484368,9 3.75,9 Z M11.7796876,4.72031236 L8.77968764,1.72031236 C8.48648429,1.427109 8.01187491,1.42757821 7.71914077,1.72031236 C7.42617202,2.01328111 7.42617202,2.48789048 7.71914077,2.78085923 L9.44062471,4.5 L4.5,4.5 C4.08515632,4.5 3.75,4.83515632 3.75,5.25 C3.75,5.66484404 4.08539057,6 4.5,6 L9.44062471,6 L7.72078085,7.71984386 C7.4278121,8.01281261 7.4278121,8.48742199 7.72078085,8.78039074 C8.0137496,9.07335949 8.48835897,9.07335949 8.78132772,8.78039074 L11.7813277,5.78039074 C12.0726557,5.48671889 12.0726557,5.01328111 11.7796876,4.72031236 Z"
                transform="translate(0 .25)"
            />
        </svg>
    );
};

export default React.memo(LogOut);
